declare var swal: any;

import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../../services/hcp.service';
import { ActorMedicalFitnessRequest, ActorMedicalFitnessInfoController } from '../../../../models/actor/actor';
import { NgbMedicalFitnessinfoModal } from '../medicalfitnessinfo/modals/medicalfitnessinfo.modal';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { CustomDateTimeService } from '../../../../services/datetime.service';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'observationsinfov2',
  templateUrl: './observations.component.html',
  styleUrls: ['./observations.component.scss']
})

export class ObservationsComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  CurrentActorMedicalFitnessRequest: ActorMedicalFitnessRequest;
  CurrentActorMedicalFitnessInfoController: ActorMedicalFitnessInfoController[];

  //
  CurrentActorEditMedicalFitnessRequest: ActorMedicalFitnessRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;

  //public MaxDateV = new Date();
  //public CanAdjustgetTimezoneOffset: boolean;
  //public MinDateV = new Date();


  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();



  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    //this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };


    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;

    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorMedicalFitnessRequest = new ActorMedicalFitnessRequest();
    this.CurrentActorMedicalFitnessInfoController = new Array<ActorMedicalFitnessInfoController>();
    this.CurrentActorMedicalFitnessRequest.ActorCode = this.ActorCode;

    this.CurrentActorMedicalFitnessRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditMedicalFitnessRequest = new ActorMedicalFitnessRequest();
    this.CurrentActorEditMedicalFitnessRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditMedicalFitnessRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CanShow === 1) {
      this.GetActorMedicalFitnessInfoController();
    }

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorMedicalFitnessRequest = null;
    this.CurrentActorMedicalFitnessRequest = new ActorMedicalFitnessRequest();
    this.CurrentActorEditMedicalFitnessRequest.ConditionalOperator = 1;
    this.CurrentActorMedicalFitnessRequest.ActorCode = this.ActorCode;
    this.CurrentActorMedicalFitnessRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    

  }
  clearData() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorMedicalFitnessRequest = null;
    this.CurrentActorMedicalFitnessRequest = new ActorMedicalFitnessRequest();
    this.CurrentActorEditMedicalFitnessRequest.ConditionalOperator = 1;
    this.CurrentActorMedicalFitnessRequest.ActorCode = this.ActorCode;
    this.CurrentActorMedicalFitnessRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  onCredentialTypeByGroup(event: any) {

    if (event != null) {

      this.CurrentActorMedicalFitnessRequest.CredentialType = event;


    }

  }
  onCredentialTypeEditByGroup(event: any) {

    if (event != null) {

      this.CurrentActorEditMedicalFitnessRequest.CredentialType = event;


    }
  }

  public onInputValidFrom(value: Date): void {

    this.CurrentActorEditMedicalFitnessRequest.ValidFrom = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditMedicalFitnessRequest.ValidTo = value;
  }

  GetActorMedicalFitnessInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorMedicalFitnessInfoController(this.CurrentActorMedicalFitnessRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorMedicalFitnessInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit() {
    if (this.ShowList) {

      return;
    }
    else {
      //  alert("not showing list, proceed to savve...");
    }
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorMedicalFitnessRequest.ConditionalOperator = 1;

    if (this.CanAdjustgetTimezoneOffset === true) {
      this.CurrentActorMedicalFitnessRequest.ValidFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorMedicalFitnessRequest.ValidFrom);
      this.CurrentActorMedicalFitnessRequest.ValidTo = this.customdatetimeservice.converToLocalTime(this.CurrentActorMedicalFitnessRequest.ValidTo);
    }

    if (this.ValidFrom != null) {



      this.CurrentActorMedicalFitnessRequest.ValidFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorMedicalFitnessRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorMedicalFitnessInfo(this.CurrentActorMedicalFitnessRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorMedicalFitnessInfoController();
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();
            


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }

  edit_(EditCurrentActorMedicalFitnessInfoController: ActorMedicalFitnessInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    this.CurrentActorEditMedicalFitnessRequest.ConditionalOperator = 2;


    //
    this.CurrentActorEditMedicalFitnessRequest.ConditionalOperator = 2;
    this.CurrentActorEditMedicalFitnessRequest.ActorCredentialCode = EditCurrentActorMedicalFitnessInfoController.ActorCredentialCode;
    this.CurrentActorEditMedicalFitnessRequest.ActorCode = EditCurrentActorMedicalFitnessInfoController.ActorCode;
    this.CurrentActorEditMedicalFitnessRequest.CredentialTypeCode = EditCurrentActorMedicalFitnessInfoController.CredentialTypeCode;
    this.CurrentActorEditMedicalFitnessRequest.CredentialType = EditCurrentActorMedicalFitnessInfoController.CredentialType;
    this.CurrentActorEditMedicalFitnessRequest.CredentialNumber = EditCurrentActorMedicalFitnessInfoController.CredentialNumber;
    this.CurrentActorEditMedicalFitnessRequest.ValidFrom = EditCurrentActorMedicalFitnessInfoController.ValidFrom;
    this.CurrentActorEditMedicalFitnessRequest.ValidTo = EditCurrentActorMedicalFitnessInfoController.ValidTo;


    if (this.CurrentActorEditMedicalFitnessRequest.ValidFrom != null) {
      var SValidFrom = new Date(this.CurrentActorEditMedicalFitnessRequest.ValidFrom);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditMedicalFitnessRequest.ValidTo != null) {
      var SValidTo = new Date(this.CurrentActorEditMedicalFitnessRequest.ValidTo);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }

    this.CurrentActorEditMedicalFitnessRequest.IssuingAuthority = EditCurrentActorMedicalFitnessInfoController.IssuingAuthority;
    this.CurrentActorEditMedicalFitnessRequest.AdditionalDetails = EditCurrentActorMedicalFitnessInfoController.AdditionalDetail;
    this.CurrentActorEditMedicalFitnessRequest.Remarks = EditCurrentActorMedicalFitnessInfoController.Remarks;

   
    this.isNew = false;
    this.isEdit = true;


  }
  onEditSubmit() {
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditMedicalFitnessRequest.ValidFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditMedicalFitnessRequest.ValidFrom);
    //  this.CurrentActorEditMedicalFitnessRequest.ValidTo = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditMedicalFitnessRequest.ValidTo);
    //}
    if (this.ValidFrom != null) {



      this.CurrentActorEditMedicalFitnessRequest.ValidFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditMedicalFitnessRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));;
    }
    this.CurrentActorEditMedicalFitnessRequest.ConditionalOperator = 2;
    this.hcpservice.SaveActorMedicalFitnessInfo(this.CurrentActorEditMedicalFitnessRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorMedicalFitnessInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');

            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }





  del_(ActorCredentialCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(ActorCredentialCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(ActorCredentialCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorMedicalFitnessRequest.ConditionalOperator = 3;
    this.CurrentActorMedicalFitnessRequest.ActorCredentialCode = ActorCredentialCode;
    this.hcpservice.SaveActorMedicalFitnessInfo(this.CurrentActorMedicalFitnessRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetActorMedicalFitnessInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }


  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal,options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
